export default __webpack_public_path__ + "static/eshop-nav-e530afb6f4c14f4842c107b4c882bb0b.svg";